<!--Planning 3D chart-->
<div class="forge-content" [style.width]="'100%'" [style.height]="'100%'" #htmlContent>
  <div *ngIf="!isLoading()" [style]="blockStyle">
    @if (richTitle && showTitle) {
<app-widget-title [title]="title" [design]="widget?.design?.title"></app-widget-title>
} @else {
<h4 [style]="titleStyle" *ngIf="showTitle">{{ title }}</h4>
}

    <span class="error" *ngIf="error">{{ error }}</span>

    <div class="content">
      <div class="panel-left">
        <mat-form-field appearance="outline" class="select" subscriptSizing="dynamic">
          <mat-label>
            {{ 'planning.selectedTasks' | translate }}
          </mat-label>

          <mat-select multiple [formControl]="tasksControl" (selectionChange)="onTasksSelected($event.value)">
            <mat-select-trigger>
              {{ selectedTasksLabel }}
            </mat-select-trigger>

            <mat-option *ngFor="let task of allTasks" [value]="task.id">
              {{task.number}} {{ task.text }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div *ngIf="!loadingTasks" class="info-box">
          @for(day of days; track day.date) {
          <div class="info-line {{day.active}}" [style.borderColor]="day.color" (click)="selectDay(day)">

            <!-- Date et compteur de métriques -->
            <div class="info-line-header">
              <div class="info-line-name">
                {{day.name}}

                <div class="info-line-count">
                  <mat-icon matTooltip="Nombre de métriques" [style.color]="day.color">apps</mat-icon>
                  {{day.metrics.length}}
                </div>
              </div>
            </div>

            <!-- Volume -->
            <div class="info-line-volume">
              <div class="volume-item">
                <mat-icon class="volume-icon">water_drop</mat-icon>
                <span class="volume-label">Coulage:</span>
                <span class="volume-value">{{day.concretingVolumeText}}m³</span>
              </div>
              
              <div class="volume-item">
                <mat-icon class="total-icon">analytics</mat-icon>
                <span class="volume-label">Total:</span>
                <span class="volume-value">{{day.volumeText}}m³</span>
              </div>
            </div>

            <!-- Types de bâtiments -->
            <div class="info-line-data">
              <div *ngFor="let bt of day.buildingTypeArray" class="info-line-data-item" [ngClass]="'active-' + bt.name"
                [matTooltip]="'planning.' + bt.name | translate">
                <mat-icon>{{ bt.icon }}</mat-icon>
                {{bt.valueText}}{{bt.unit}}
              </div>
            </div>
          </div>
          }
        </div>

        <ng-container *ngIf="loadingTasks">
          <div class="loading-tasks">
            <app-spinner [text]="'planning.loading.loadingTasks' | translate"></app-spinner>
          </div>
        </ng-container>
      </div>

      <div class="forge-container">
        <app-viewer #viewer id="planning-viewer" [context]="'dashboard'" [tasks]="tasks" [model]="model"
          [project]="project" [planning]="planning" [currentDate]="currentDate" [fragments]="fragments"
          [metrics]="metrics" [startDate]="startDate" [endDate]="endDate" [currentTask]="currentTask"
          [currentMetric]="currentMetric" [selectedFragments]="selectedFragments" [currentDay]="currentDay"
          [selectedTasks]="selectedTasks" [selectedMetrics]="selectedMetrics" [displayMetric]="displayMetric"
          [displayModel]="displayModel$" (onTaskUpdate)="onTaskUpdate($event)" (onTaskSelected)="onTaskSelected($event)"
          (onLoaded3D)="onLoaded3D($event)">
        </app-viewer>
      </div>
    </div>
  </div>

  <app-widget-loading *ngIf="isLoading()" [graphType]="widget?.graphType"></app-widget-loading>
  <div id="chart-rendered" *ngIf="chartRendered && !isLoading()"></div>
</div>